import ResetPasswordFieldControl from 'global/resetPassword/ResetPasswordFieldControl';
import EmailAlreadyRegistered from 'global/emailAlreadyRegistered/EmailAlreadyRegistered';
import ModalManager from 'global/modal/ModalManager';
import { getNodeFromString } from 'global/common/globalUtils';
import { experianEmailLookup } from 'global/experianEmailValidation/experianEmailValidation';

const { FormControl } = window.od;

class AboutYouFormControl extends FormControl {
	constructor(formNode) {
		super(formNode);
		this.emailAlreadyRegisteredInstance = new EmailAlreadyRegistered();
	}

	initFieldControl(field) {
		if (field.name === 'password') {
			const rules = this.rules[field.name];
			return new ResetPasswordFieldControl(field, rules);
		}
		return super.initFieldControl(field);
	}

	attachFormEvents() {
		const onSubmitMethod = this.handleOnSubmitMethod(
			window.od.isExperianCheckActive,
		).bind(this);

		this.form.addEventListener('submit', e => onSubmitMethod(e));
	}

	handleOnSubmitMethod(isExperianCheckActive) {
		if (isExperianCheckActive) return this.onSubmitWithExperianCheck;
		return this.onSubmit;
	}

	async onSubmitWithExperianCheck(event) {
		event.preventDefault();

		const formEmailInput = event.target.querySelector('#email');
		const isFormValid = await this.checkFormIsValid(formEmailInput.value);

		if (isFormValid) {
			this.experianEmailValidationCheck(
				event,
				formEmailInput,
				this.submitForm.bind(this, event),
			);
		}

		return false;
	}

	async checkFormIsValid(formEmailInput) {
		const isRegistered =
			await this.emailAlreadyRegisteredInstance.isEmailRegistered(
				formEmailInput,
			);
		this.emailAlreadyRegisteredInstance.isEmailAlreadyRegistered = isRegistered;
		this.emailAlreadyRegisteredInstance.displayValidation();
		if (isRegistered) {
			return false;
		}
		return this.isFormValid();
	}

	async experianEmailValidationCheck(event, formEmailInput, callback) {
		const submitBtn = event.target.querySelector('#aboutYouSubmit');
		const submittingMessage = document.getElementById(
			'aboutYouFormSubmittingMessage',
		);

		this.disableSubmitBtn(submitBtn, submittingMessage);

		const experianResult = await experianEmailLookup(
			formEmailInput.value,
			window.od.aboutYouFormPageType || 'checkout',
		).catch(() => {
			this.enableSubmitBtn(submitBtn, submittingMessage);
			this.experianCheckFailed(callback);
			return null;
		});

		if (experianResult && experianResult.status === 200) {
			const html = getNodeFromString(experianResult.data);
			const modal = this.initModal(html);
			this.enableSubmitBtn(submitBtn, submittingMessage);
			this.attachModalSubmitHandler(modal.modal.element, callback);
		} else {
			callback();
		}
	}

	submitForm(event) {
		event.target.submit();
	}

	initModal(html) {
		const modalId = html.id;
		const modal = new ModalManager();
		modal.insertResponse(html, modalId);
		return modal;
	}

	attachModalSubmitHandler(modal, callback) {
		const submitBtn = modal.querySelector('#submitAboutYouForm');
		submitBtn.addEventListener('click', callback);
	}

	disableSubmitBtn(submitBtn, submittingMessage) {
		if (!submitBtn || !submittingMessage) return;

		const btnWaitingClass = 'btn--is-waiting';
		this.addClassToElem(btnWaitingClass, submitBtn);
		this.removeClassFromElem('d-none', submittingMessage);
		submitBtn.setAttribute('readonly', '');
		submitBtn.setAttribute('disabled', '');
	}

	enableSubmitBtn(submitBtn, submittingMessage) {
		if (!submitBtn || !submittingMessage) return;

		const btnWaitingClass = 'btn--is-waiting';
		this.removeClassFromElem(btnWaitingClass, submitBtn);
		this.addClassToElem('d-none', submittingMessage);
		submitBtn.removeAttribute('readonly');
		submitBtn.removeAttribute('disabled');
	}

	experianCheckFailed(callback) {
		callback();
	}

	addClassToElem(className, elem) {
		elem.classList.add(className);
	}

	removeClassFromElem(className, elem) {
		elem.classList.remove(className);
	}
}

export default AboutYouFormControl;
